(() => {
    "use strict";

    const GROUP_SIZE = 3;
    const DISPLAY_MS = 5500;
    const FADE_MS = 520;

    let pageSignal = null;
    let rotateTimer = null;

    function prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function readPool() {
        const node = document.getElementById("catalog-collage-data");
        if (!node?.textContent) {
            return [];
        }
        try {
            const parsed = JSON.parse(node.textContent);
            return Array.isArray(parsed)
                ? parsed.filter((item) => item?.src && item?.url)
                : [];
        } catch (_error) {
            return [];
        }
    }

    function stopRotation() {
        if (rotateTimer !== null) {
            window.clearInterval(rotateTimer);
            rotateTimer = null;
        }
    }

    function chunkPool(pool, startIndex) {
        const items = [];
        for (let offset = 0; offset < GROUP_SIZE; offset += 1) {
            items.push(pool[(startIndex + offset) % pool.length]);
        }
        return items;
    }

    function updateCollage(root, pool, startIndex) {
        const cards = root.querySelectorAll(".catalog-collage-card");
        const group = chunkPool(pool, startIndex);
        cards.forEach((card, index) => {
            const item = group[index];
            if (!item) {
                return;
            }
            card.href = item.url;
            card.dataset.slot = String(index + 1);
            const image = card.querySelector("img");
            if (image) {
                image.src = item.src;
                image.alt = item.nome ?? "";
            }
            const label = card.querySelector(".catalog-collage-label");
            if (item.label) {
                if (label) {
                    label.textContent = item.label;
                } else {
                    const span = document.createElement("span");
                    span.className = "catalog-collage-label";
                    span.textContent = item.label;
                    card.appendChild(span);
                }
            } else if (label) {
                label.remove();
            }
        });
    }

    function boot() {
        pageSignal?.abort();
        pageSignal = new AbortController();
        const { signal } = pageSignal;

        stopRotation();

        const root = document.querySelector("[data-catalog-collage]");
        if (!root || root.dataset.collageRotating !== "true") {
            return;
        }

        const pool = readPool();
        if (pool.length <= GROUP_SIZE || prefersReducedMotion()) {
            return;
        }

        let startIndex = 0;
        rotateTimer = window.setInterval(() => {
            startIndex = (startIndex + GROUP_SIZE) % pool.length;
            root.classList.add("is-rotating");
            window.setTimeout(() => {
                updateCollage(root, pool, startIndex);
                root.classList.remove("is-rotating");
            }, FADE_MS);
        }, DISPLAY_MS);

        signal.addEventListener("abort", stopRotation, { once: true });
    }

    window.siteReady(boot);
})();
